// ÜRETİLMİŞTİR — ELLE DÜZENLEME.
// Kaynak: `ruleset-fcl/ruleset_fcl_regulation.json`
// Yeniden üretmek için: `python3 ops/gen_fcl_articles.py`
//
// CRA `src/` dışından import'a izin vermediği için kural seti buraya
// türetilir. Kaynak TEK dosyadır; bu bir kopya değil, çıktıdır.

const FCL_REG = {
  "reference": "SHT-FCL — Uçak, Helikopter, Dikey Kalkışlı Hava Aracı ve Hava Gemisi Pilotu Lisanslandırma Talimatı (Yayım 04/09/2024, Değişiklik No 00)",
  "revision": "Değişiklik No 00",
  "issued": "2024-09-04",
  "scope": "Lisans/yetki GEÇERLİLİĞİ. Görev ve dinlenme sınırları bu talimatta DEĞİL, SHT-FTL/HG'dedir — iki kural seti karıştırılmaz.",
  "recent_experience": {
    "reference": "FCL.060 — Son dönem tecrübesi",
    "applies_to": "Ticari hava taşımacılığı VEYA yolcu taşımacılığı amacıyla kullanım",
    "pic_or_second_pilot": {
      "reference": "FCL.060(a)(1)",
      "window_days": 90,
      "takeoffs": 3,
      "approaches": 3,
      "landings": 3,
      "same_type_or_class": true,
      "ffs_accepted": true,
      "single_or_multi_pilot_ops": true,
      "note": "Son 90 gün içerisinde aynı tip/sınıf hava aracında veya o tipin/sınıfın tam uçuş simülatöründe (FFS) en az 3 kalkış, yaklaşma ve iniş. 3 kalkış ve iniş, pilotun imtiyazlarına bağlı olarak tek pilotlu veya çok pilotlu operasyonlarda yapılmış olabilir."
    },
    "night_pic": {
      "reference": "FCL.060(a)(2)",
      "window_days": 90,
      "takeoffs": 1,
      "approaches": 1,
      "landings": 1,
      "at_night": true,
      "ffs_accepted": true,
      "instrument_rating_required": true,
      "note": "Gece şartlarında PIC olarak uçmak için: son 90 günde gece şartlarında en az 1 kalkış, yaklaşma ve iniş; VE aletli uçuş yetkisi (IR) sahibi olmak."
    },
    "cruise_relief_second_pilot": {
      "reference": "FCL.060(a)(3)",
      "requires_a1": true,
      "sectors_90d": 3,
      "ffs_refresher_max_interval_days": 90,
      "note": "Seyir safhası yedek ikinci pilot: (a)(1) gereklilikleri karşılanacak; VEYA son 90 günde aynı tip/sınıfta uzun uçuşlarda en az 3 sektörde seyir safhası yedek ikinci pilot görevi; VEYA FFS'de 90 günü aşmayan aralıklarla güncellik/tazeleme eğitimi. Tazeleme eğitimi işleticinin uçuş operasyon gerekliliği tazeleme eğitimiyle birleştirilebilir."
    },
    "multiple_similar_types": {
      "reference": "FCL.060(a)(4)",
      "note": "Benzer sevk-idare ve operasyon karakteristiklerine sahip birden çok UÇAK tipi imtiyazı varsa, (a)(1)'deki 3 kalkış/yaklaşma/iniş SHT-21'e göre oluşturulan operasyonel uygunluk verilerinde tanımlandığı şekilde gerçekleştirilebilir."
    },
    "multiple_similar_helicopters": {
      "reference": "FCL.060(a)(5)",
      "applies_to": "kompleks olmayan helikopter tipleri",
      "each_type_hours_6mo": 2,
      "note": "Son 6 ayda bu tiplerin her biriyle en az 2 saat uçmuş olmak koşuluyla, (a)(1)'deki 3 kalkış/yaklaşma/iniş bu tiplerden yalnız birinde gerçekleştirilebilir."
    },
    "cat_extension": {
      "reference": "FCL.060(b)(1)",
      "extends": [
        "FCL.060(a)(1)",
        "FCL.060(a)(2)"
      ],
      "max_window_days": 120,
      "condition": "Pilotun bir tip yetkisi öğretmeni (TRI) veya kontrol pilotu nezaretinde hat uçuşu gerçekleştirmesi",
      "note": "Ticari hava taşımacılığı bağlamında 90 günlük süre azami 120 güne uzatılabilir."
    },
    "non_compliance_remedy": {
      "reference": "FCL.060(b)(2)",
      "note": "Gereklilik karşılanmazsa: Alt Bölüm J'ye uygun yeterliliğe sahip bir öğretmenle eğitim uçuşu tamamlanır. Uçuş, kullanılacak hava aracında veya o tipteki bir FFS'de yapılır ve (a)(1) ile (a)(2)'deki gereklilikleri içermelidir. İmtiyazlar bu eğitimden ÖNCE kullanılamaz."
    }
  },
  "measurability": {
    "note": "Bu kural seti HENUZ MOTORA BAGLANMADI. Asagidaki liste, bugunku veriyle neyin olculebilecegini durustce soyler — baglanirsa hangi satirin gercekten zorlanabilecegi buradan okunur.",
    "measurable_today": [
      "FCL.060(a)(1) kalkis/inis sayisi — `crew_duties.sectors` her sektorde `role` (PF/PM) tasir; bir sektor 1 kalkis + 1 inistir. Duty history zaten 'SECTORS AS PF' diye sayiyor."
    ],
    "not_measurable_today": [
      "YAKLASMA sayisi — ayri kaydedilmiyor (sektor sayisindan turetmek varsayim olurdu)",
      "GECE kalkis/inis — sektorde gece isareti yok (FCL.060(a)(2))",
      "FFS (simulator) kalkis/inisleri — TRAINING modulunde GRND_FSTD kalemi var ama kalkis/inis sayisi tutulmuyor",
      "TIP/SINIF ayrimi — sektor ucak tipine baglanmiyor (tek tipte fark etmez, filo cesitlenirse eder)",
      "TRI/kontrol pilotu nezaretinde hat ucusu — 120 gun uzatmasinin (b)(1) sarti kayitli degil"
    ]
  },
  "night_definition": {
    "reference": "SHT-FCL Md.4(r)",
    "text": "Gece: Akşam alacakaranlığın sonu (günbatımı+30 dk.) ve sabah alacakaranlığın başlangıcı (gündoğumu−30 dk.) arasındaki süreyi",
    "sunset_margin_min": 30,
    "sunrise_margin_min": 30,
    "note": "Talimat sivil alacakaranlığı 30 DAKİKA olarak sabitlemiştir; güneşin ufkun 6° altında olduğu gerçek alacakaranlık enlem ve mevsimle değişir, ama bizi bağlayan metin budur. ICAO Annex 15 GEN 2.7 devletlerin sunrise/sunset tablolarını AIP'de yayımlamasını ister ve tablo yerine FORMÜL kullanmayı açıkça kabul eder — hesaplayarak bulmamız bu yüzden meşrudur ve geçmişe dönük de çalışır."
  },
  "company": {
    "note": "Mevzuatta karşılığı OLMAYAN veya metnin açık bıraktığı yerde operatörün yaptığı seçimler. SHT-FCL'den gelenler gibi kilitli değildir — ama gevşetme yönünde değiştirilemez.",
    "night_recency_interpretation": {
      "label": "NIGHT RECENCY — HOW THE THREE ARE COUNTED",
      "value": "separate_events",
      "options": [
        "same_sector",
        "separate_events"
      ],
      "reference": "FCL.060(a)(2)",
      "note": "Madde *\"gece şartlarında en az 1 kalkış, yaklaşma ve inişi\"* der ama bunların AYNI SEKTÖRDE olması gerektiğini SÖYLEMEZ. Serkan (4 Eyl 2026): *\"Ayrı ayrı olabilir, tek başına bir uçuşta da gerçekleşebilir — zaten bu açık: bir uçuş gündüz başlayıp gece inişiyle bitebilir.\"*  Bu yüzden pencerede EN AZ BİR gece kalkışı VE EN AZ BİR gece inişi aranır; aynı sektörde olmaları gerekmez. Yakınlığı bağlayan, ikisinden ESKİ olanının yaşıdır."
    },
    "measurement_basis": {
      "label": "PF SECTOR COUNTS AS ALL THREE",
      "value": true,
      "reference": "FCL.060(a)(1)",
      "note": "Serkan (4 Eyl 2026): *\"Bizde PF yaklaşma, iniş, kalkış hepsini yapar — PF olarak tanımlıysa 3 durum gerçekleşir.\"*  Bu yüzden bir PF sektörü kalkış, yaklaşma ve iniş olarak sayılır. PM sektörü sayılmaz."
    },
    "alert_thresholds": {
      "label": "RECENCY ALERT — DAYS",
      "amber_from_days": 60,
      "red_from_days": 80,
      "reference": "— company rule",
      "note": "Serkan (4 Eyl 2026): *\"60'a kadar yeşil, 80'ne kadar amber, 90 gün olduğunda KIRMIZI.\"*  Ölçü 3. en yeni PF sektörünün yaşıdır; 90 günü doldurduğunda sayı 3'ün altına iner. Mevzuatta uyarı eşiği YOKTUR, bu tamamen operatörün erken uyarı tercihidir."
    },
    "night_recency_ir_exemption": {
      "label": "NIGHT RECENCY — IR EXEMPTION",
      "value": "ir_exempt",
      "options": [
        "strict",
        "ir_exempt"
      ],
      "reference": "FCL.060(a)(2)(ii)",
      "note": "🔴 SHT-FCL'in Türkçe metni iki OLUMSUZU 'veya' ile bağlıyor: *\"(i) … icra etmemiş ise; VEYA (ii) aletli uçuş yetkisine (IR) sahip DEĞİL ise\"* — kelimesi kelimesine okununca ikisi de gerekli çıkar (strict). EASA'nın orijinali (1178/2011 FCL.060(b)(2)) ise 'unless (i) … OR (ii) holds an IR' der; orada IR gece yakınlığının YERİNE geçer. İki olumsuzu 'veya' ile bağlamak mantığı ters çevirir. Operatör EASA okumasını seçmiştir. DAYANAK — Serkan (5 Eyl 2026): *\"Bu uçakta uçan herkes ATPL, yani IR yetkisi var, ve kaptan.\"*  ATPL(A) zaten geçerli bir IR gerektirir, dolayısıyla FCL.060(a)(2)(ii) bütün ekip için sağlanır. ⚠️ Muafiyet BU KOŞULA bağlıdır: ATPL'siz ya da IR'si askıya alınmış bir pilot uçuş ekibine girerse bu satır yeniden ele alınmalıdır — kayıtta pilot başına lisans/IR alanı YOKTUR."
    }
  }
};

export default FCL_REG;
